module.exports = __webpack_public_path__ + "0536c54f5cf65b94c36e2c046c593aa8.png";